// extracted by mini-css-extract-plugin
module.exports = {"modal-wrapper":"W5FDc","modal":"Ia5a0"};